<script>
    import { Col, Container, Row } from 'sveltestrap'
</script>

<Container class="min-vh-100 h-100">
    <Row>
        <Col class="d-flex vh-100 flex-column justify-content-center">
            <h1 class="text-center">Welcome!</h1>
            <p class="text-center">Please talk with your Success Coach about getting your portal ready!</p>
        </Col>
    </Row>
</Container>
